import { useTranslation } from 'react-i18next';
import type { ChartArtifact } from './chartModel.js';

export function ChartMetadata({ artifact, locale }: { artifact: ChartArtifact; locale: string }) {
  const { t } = useTranslation('agent');
  const items: string[] = [];
  if (artifact.provenance !== undefined) {
    const parts = [
      artifact.provenance.source,
      artifact.provenance.metric,
      artifact.provenance.period,
    ].filter((part): part is string => part !== undefined);
    if (parts.length > 0) {
      items.push(`${t('artifacts.chart.provenance')}: ${parts.join(' · ')}`);
    }
  }
  if (artifact.createdAt !== undefined) {
    items.push(`${t('artifacts.chart.createdAt')}: ${formatDate(artifact.createdAt, locale)}`);
  }
  if (items.length === 0) return null;
  return (
    <div style={{ color: 'var(--fg-3)', fontSize: 'var(--fz-12)' }}>
      {items.map((item, index) => (
        <span key={item}>
          {index > 0 ? ' · ' : null}
          {item}
        </span>
      ))}
    </div>
  );
}

function formatDate(value: string, locale: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat(locale, { dateStyle: 'short', timeStyle: 'short' }).format(date);
}
